import React from "react";
import { Link, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import openSocket from 'socket.io-client';
import * as dashboardActions from "../../actions/dashboardActions";
import * as SVGICONS from "../../images/img/images";
import RoleAwareComponent from "../authorization/roleaware";
import * as ImageUrl from "../../constants/constant.js";
import * as constant from "../../constants/constant";
import { Typeahead } from 'react-bootstrap-typeahead';
import Autocomplete from 'react-google-autocomplete';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as url from '../../tools/config';
// import myappointmentComponent from "../appointment/myappointment.component";
import $ from 'jquery'
// import AppsUnderDevlopment from "../marketing/appsUnderDevelopement";
import { isPatient, IsAuthorizedUrl } from "../common/AuthHOC";
import { history } from '../../store/configureStore'
import Mysetting from "../setting/mysetting";
import MysettingNew from '../setting/mySettingNew'
// import AsyncBlogsFrontEnd from '../../components/marketing/blog';
import Myappointment from "../appointment/myAppointment";
import BookAppointment from "../appointment/bookAppointment";
import HealthRecord from "../healthrecord/healthRecord";
import Notifications from "../common/notifications";
import BookAppointmentCalendar from "../appointment/bookApointmentCalendar";
import SpecialistDetails from "../specialist/specialistDetails";
import AppointmentDetails from "../appointment/appointmentDetails";
import AppointmentPayment from "../payment/appointmentPayment";
import AppointmentConfirmation from "../appointment/appointmentConfirmation";
import BlogDetails from "../blog/blogDetails";
import Bookingconfirmation from "../appointment/bookingconfirmation";
import CallWaiting from "../videocall/components/callWaiting";
import VideoCallConnect from "../videocall/components/videoCallConnect";
import VideoCallReceive from "../videocall/components/videoCallReceive";
import WaitingRoomReceiver from "../videocall/components/watingRoomReceiver";
import AddRating from "../rating/addRating";
import PatientAppointmentDetail from "../appointment/patientAppointmentDetail";
import Blog from "../blog/blog";
import moment from 'moment';
import ErrorPage from "../common/404";
import verifyUser from "../healthrecord/verifyUser";
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
import * as userActions from '../../actions/usersActions';
import consultationpdf from "../specialist/pages/consultationpdf";

const CHECK_INTERVAL = 5000 // in ms

//landing page presentational component
class Dashboard extends RoleAwareComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isSearch: false,
            spinner: false,
            specialistList: [],
            specializationList: [],
            searchSpecialization: "",
            searchZipcode: localStorage.getItem("zipCode")
                ? localStorage.getItem("zipCode")
                : "",
            searchGender: "",
            feeRange: [],
            searchRateValue: [],
            searchMileDistance: 0,
            activePage: 1,
            count: 10,
            user: {},
            logoutButton: false,
            sidebartoggle: true,
            specialization: '',
            userDetails: '',
            searchingSpecialist: true
        };
        this._logout = this._logout.bind(this);
        this.onChange = this.onChange.bind(this);
        this.searchByDashBoard = this.searchByDashBoard.bind(this);
        this.isClicked = this.isClicked.bind(this);
        // this.onLogoutclick = this.onLogoutclick.bind(this);
        this.toggle = this.toggle.bind(this);
        // if(localStorage.getItem('userType')=='patient'){
        // 	this.initInterval();
        // 	}
        this.updateAddress = this.updateAddress.bind(this);

    }
    updateAddress(address) {
        let self = this;
        var placeSearch, autocomplete;
        var componentForm = {
            street_number: 'Street Number',
            route: 'Route',
            postal_town: 'Town',
            locality: 'locality',
            administrative_area_level_1: 'State ',
            country: 'country',
            postal_code: ' Zip Code'
        };

        for (var i = 0; i < address.address_components.length; i++) {
            var addressType = address.address_components[i].types[0];
            if (componentForm[addressType]) {
                let val = address.address_components[i][componentForm[addressType]];
                componentForm[addressType] = address.address_components[i].long_name;
            }

        }
        var zip = componentForm.postal_code != ' Zip Code' ? componentForm.postal_code + ', ' : ''
        var town = componentForm.postal_town != 'Town' ? componentForm.postal_town + ', ': componentForm.locality != 'locality' ? componentForm.locality + ', ' : ''
        var country = componentForm.country != 'country' ? componentForm.country : ''
        country = country.toLowerCase()
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
        localStorage.setItem('country_long', country);
        self.setState({
            searchZipcode: zip + town + country
        })
    }
    // 	initInterval() {

    // 		
    // 		var state = this.state

    // 		state.user = JSON.parse(localStorage.getItem('user'));

    // 		setInterval(() => {
    // 			

    // if(localStorage.getItem('userType')== 'patient') {
    // 	this.setState(state);
    // }
    // 		}, CHECK_INTERVAL);
    // 	}
    toggle(e, menuClicked) {
        var windowWidth = $(window).width();
        if (windowWidth < 768) {
            if (e == true) {
                $("body").toggleClass("sidebar-open");
            } else {
                $("body").toggleClass("sidebar-open");
            }
        }

        // if(windowWidth < 768 ){

        // 	$("body").toggleClass("sidebar-open");
        // }
        if (windowWidth >= 768) {
            if (e == true) {
                $("body").toggleClass("sidebar-collapse");
            } else if (e == false) {
                $("body").toggleClass("sidebar-collapse");
            }
        }




    }

    //obsolete function
    // onLogoutclick(data) {
    //     // if (this.state.logoutButton == false) {
    //     this.setState({
    //         logoutButton: !this.state.logoutButton
    //     });
    //     // }
    //     // else {
    //     //     this.setState({
    //     //         logoutButton: false
    //     //     });
    //     // }
    // }


    componentWillMount() {
        this.setState({ searchingSpecialist: true })
        let userDetail = {
			userId: localStorage.getItem('userId')
		}
        if (isPatient() == false) {

            this.props.history.push('/')
        }
        this.props.actions.getSpecializationList(this.props);
		// this.props.userActions.getUserDetails(userDetail);


    }

    componentWillReceiveProps(nextProps) {

        this.setState({
            specializationList: nextProps.specializationList,
            userDetails: nextProps.userDetails
        });
        // if (nextProps.specialistSearchSuccess == true) {

        //     this.props.history.push('/dashboard/book-appointment')
        //     this.props.actions.searchingComplete();


        // }
    }

    onChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }
    componentDidMount() {
        const user = JSON.parse(localStorage.getItem("user"));

    }

    searchByDashBoard() {
        this.setState({
            spinner: true,

        })
        if (
            this.state.specialization != undefined ||
            this.state.searchZipcode != ""
        ) {
            localStorage.setItem('specializationId', this.state.specialization);
            localStorage.setItem('specializationName', this.state.specializationName);
            localStorage.setItem('zipcode', this.state.searchZipcode);
            let tableObj = {
                page: this.state.activePage,
                count: this.state.count,
                searchSpecialization: this.state.specialization,
                searchZipcode: this.state.searchZipcode,
                searchSpecializationName: this.state.specializationName

            };

            this.props.actions.getSpecialistList(tableObj, this.props);

            this.setState({
                specialization: '',
                specializationName: '',
                searchZipcode: ''
            });
        } else {

            localStorage.setItem('specializationId', this.state.specialization);
            localStorage.setItem('specializationName', this.state.specializationName);
            localStorage.setItem('zipcode', this.state.searchZipcode);
            this.props.history.push('/dashboard/book-appointment')
        }
    }
    _logout(event) {

        let userId = localStorage.getItem("userId");
        this.props.actions.logout({ 'userId': userId });
        let locality = localStorage.getItem('locality');
        let localityState = localStorage.getItem('localityState');
        let localityCountry = localStorage.getItem('localityCountry');
        event.preventDefault();
        localStorage.clear();
        localStorage.setItem('locality', locality)
        localStorage.setItem('localityState', localityState)
        localStorage.setItem('localityCountry', localityCountry)
        this.props.history.push("/");
    }
    isClicked() {

        localStorage.setItem('isDisclaimerBlog', true);
        localStorage.setItem('isClicked', 'true')
    }
    handleOutsideClick = (e) => {
        // ignore clicks on the component itself
        if (this.node && this.node.contains(e.target)) {
            return;
        }

        this.handleClick();
    }
    handleClick = () => {
        if (!this.state.logoutButton) {
            // attach/remove event handler
            document.addEventListener('click', this.handleOutsideClick, false);
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }

        this.setState(prevState => ({
            logoutButton: !prevState.logoutButton,
        }));
    }
    render() {

        // var children = React.Children.map(
        // 	this.props.children,
        // 	function (child) {
        // 		return child;
        // 	}.bind(this)
        // );
        var specializationList = this.state.specializationList ? this.state.specializationList : [];
        var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        if (user && user.gender == undefined) {
            user = { ...user, gender: 'Male' }
            // localStorage.setItem('user', JSON.stringify(user));
            // user = JSON.parse(localStorage.getItem("user"));
        }
        // var gender = localStorage.getItem('user')
        var defaultImagePath = (user && user.gender) == 'Male' ?
            constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        var imagePath = ''
        if (user && user.image == "noUserImage.jpg") {
            imagePath = user && user.gender == 'Male' ?
                constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png";
        } else {
            imagePath =
                ImageUrl.PRODUCTION_IMAGE_URL +
                "uploads/" +
                localStorage.getItem("userId") +
                "/" +
                (user && user.image);
        }
        var sidebartoggle = true;
        var windowWidth = $(window).width();
        var condition = user &&  (user.userCreatedBy == 'S' || user.userName == undefined);
        var condition2 = windowWidth >= 768;
        const {
            children,
            location
        } = this.props
        let userLocation;
        let userLocationShort;
        if ( localStorage.getItem('locality') ) {
            userLocationShort = localStorage.getItem('locality');
            userLocation = `${localStorage.getItem("locality")}, ${localStorage.getItem("localityState")}, ${localStorage.getItem("localityCountry")}`
        } else {
            userLocationShort = ''
            userLocation = "Turn On your Location"
        }

        const { userProfDetails } = this.props

        return (
            <div className="wrapper">
                <header className="main-header">
                    <ToastContainer />
                    {/* <!-- Logo -->  */}

                    <Link to='/dashboard/my-appointment' className="logo" >
                        <span className="logo-mini">
                            <img src={require("../../images/img/logo_er_ms.png")} alt="" />
                        </span>
                        <span className="logo-lg">
                            <img src={require("../../images/img/logo_er_old.png")} alt="" />
                        </span>
                    </Link>

                    <nav className="navbar navbar-static-top" role="navigation">
                        <Link to="#"
                            className="sidebar-toggle"
                            data-toggle="push-menu"
                            role="button"
                        // onClick={this.toggle}
                        >

                            <img onClick={this.toggle.bind(this, !sidebartoggle)}
                                src={require("../../images/img/menu_list.svg")}
                                alt=""
                            />
                            <span className="sr-only">Toggle navigation</span>
                        </Link>
                     
               
                        <div className="navbar-custom-menu">
                            <ul className="nav navbar-nav">
                                <li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
                                    <Link
                                        to="#"
                                        className="dropdown-toggle"
                                        data-toggle="dropdown"
                                    >
                                        <img
                                            src={imagePath}
                                            className="user-image"
                                            alt="User Image"
                                            onError={e => {
                                                e.target.src = defaultImagePath;
                                            }}
                                        />
                                        <span className="hidden-xs name-capitalize">
                                            {user && user.userName ? user && user.userName : "Medfix User"}
                                        </span>
                                    </Link>
                                    <ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

                                        <li className="user-setting">	<Link to={{ pathname: "/dashboard/my-setting", state: 1 }}>

                                            <img
                                                src={require('../../images/Slicing/Settings-profile.png')}
                                                className="user-image"
                                                alt="User Image"
                                                onError={e => {
                                                    e.target.src = defaultImagePath;
                                                }}
                                            />
                                            <span>Settings</span>
                                        </Link></li>
                                        <li
                                            className="user-footer passwordLink"
                                        // style={{ textAlign: "center" }}
                                        >

                                            <Link to="#"
                                                className="uploadLink"
                                                onClick={this._logout}
                                            >
                                                <img
                                                    src={require('../../images/Slicing/logout-profile.png')}
                                                    className="user-image"
                                                    alt="User Image"
                                                    onError={e => {
                                                        e.target.src = defaultImagePath;
                                                    }}
                                                />
                                                <span style={{ color: "#000" }}>	Sign out</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </header>

                <aside className="main-sidebar">
                    <section className="sidebar">
                        <ul className="sidebar-menu" data-widget="tree">
                            <li
                                className={
                                    condition ? 'DisabledSidebar' : (location.pathname === "/dashboard/book-appointment" ||
                                        location.pathname === "/dashboard/book-appointment-calendar" ||
                                        location.pathname === "/dashboard/appointment-details" ||
                                        location.pathname === "/dashboard/appointment-confirmation" ||
                                        location.pathname === "/dashboard/booking-confirmation") 
                                        ? "active" : ''
                                }
                                

                            >

                                <Link to={!condition ? "/dashboard/book-appointment" : "/dashboard/my-setting"}
                                    onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}

                                >
                                    <i className="fa ">
                                        <SVGICONS.BookAppointmentSvg />
                                    </i>
                                    <span>Book an Appointment</span>
                                </Link>
                            </li>
                            <li
                                className={
                                    condition ? 'DisabledSidebar' : location.pathname === "/dashboard/my-appointment" ? "active" : ""
                                }
                                onClick={this.isClicked}>

                                <Link
                                    to={{ pathname: !condition ? "/dashboard/my-appointment" : "/dashboard/my-setting", state: 1 }}
                                    onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}
                                >
                                    <i className="fa ">
                                        <SVGICONS.MyAppointmentSvg />
                                    </i>
                                    <span>My Appointments </span>
                                </Link>

                            </li>
                            
                            <li
                                className={
                                    condition ? 'DisabledSidebar' : location.pathname === "/dashboard/my-health-record"
                                        ? "active"
                                        : ""
                                }
                            >
                                <Link  to={!condition ? "/dashboard/verify-user" : "/dashboard/my-setting"}
                                    onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
                                    <i className="fa ">
                                        <SVGICONS.MyHealthRecordsSvg />
                                    </i>
                                    <span>My Health Records</span>
                                </Link>
                            </li>
                            <li className={condition ? 'DisabledSidebar' : location.pathname === "/dashboard/blog" ? "active" : ""} onClick={this.isClicked} >

                                <Link to={{ pathname: !condition ? "/dashboard/blog" : "/dashboard/my-setting", state: 1 }}
                                    onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
                                    <i className="fa ">
                                        <SVGICONS.HealthTipSvg />
                                    </i>
                                    <span>Blog </span>
                                </Link>
                            </li>
                            <li className={condition ? 'DisabledSidebar' : (location.pathname === '/dashboard/notifications') ? 'active' : ''}>
                                <Link to={!condition ? { pathname: "/dashboard/notifications", state: 1 } : "/dashboard/my-setting"}
                                    onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
                                    <i className="fa ">
                                        <SVGICONS.NotificationsSvg />
                                    </i> <span>Notifications </span> </Link>
                            </li>
                            <li
                                className={location.pathname === "/dashboard/my-setting" ? "active" : ""}
                                onClick={this.isClicked}
                            >

                                <Link to={{ pathname: "/dashboard/my-setting", state: 1 }}
                                    onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
                                    <i className="fa ">
                                        <SVGICONS.SettingsSvg />
                                    </i>
                                    <span>Settings</span>
                                </Link>
                            </li>
                        </ul>

                    </section>
                </aside>
                {/* <Mysetting /> */}
                <Switch>
                    <Route exact path="/dashboard" component={MysettingNew} />
                    <Route exact path="/dashboard/my-setting" exact component={MysettingNew} />
                    <Route exact path="/dashboard/blog" component={Blog} />
                    <Route exact path="/dashboard/my-appointment" component={Myappointment} />
                    <Route exact path="/dashboard/book-appointment" component={BookAppointment} />
                    <Route exact path="/dashboard/verify-user" component={verifyUser} />
                    <Route exact path="/dashboard/my-health-record" component={HealthRecord} />
                    <Route exact path="/dashboard/my-health-record/pdf" component={consultationpdf} />
                    <Route exact path="/dashboard/notifications" component={Notifications} />
                    <Route exact path="/dashboard/book-appointment-calendar" component={BookAppointmentCalendar} />
                    <Route exact
                        path="/dashboard/specialist-details/:availabilityId"
                        component={SpecialistDetails}
                    // onEnter={isPatient}
                    />
                    <Route exact
                        path="/dashboard/appointment-details"
                        component={AppointmentDetails}
                    // onEnter={isPatient}
                    />
                    <Route exact
                        path="/dashboard/appointment-payment"
                        component={AppointmentPayment}
                    // onEnter={isPatient}
                    />
                    <IsAuthorizedUrl exact
                        path="/dashboard/appointment-confirmation"
                        component={AppointmentConfirmation}
                    // onEnter={isAuthorizedUrl}
                    />
                    <Route exact
                        path="/dashboard/blogdetails/:blogId/:userType"
                        component={BlogDetails}
                    // onEnter={isPatient}
                    />
                    <IsAuthorizedUrl exact
                        path="/dashboard/booking-confirmation"
                        component={Bookingconfirmation}
                    // onEnter={isAuthorizedUrl}
                    />
                    <Route exact
                        path="/dashboard/waiting-room-caller"
                        component={CallWaiting}
                    // onEnter={isPatient}
                    />
                    <Route exact
                        path="/dashboard/video-call-connect/:videoId"
                        component={VideoCallConnect}
                    // onEnter={isPatient}
                    />
                    <Route exact
                        path="/dashboard/video-call-receive/:videoId"
                        component={VideoCallReceive}
                    // onEnter={isPatient}
                    />
                    <Route exact
                        path="/dashboard/video-call-receive/:videoId/:IOSkey"
                        component={VideoCallReceive}
                    // onEnter={isPatient}
                    />
                    <Route exact
                        path="/dashboard/waiting-room-receiver/:videoId/:appointmentId"
                        component={WaitingRoomReceiver}
                    // onEnter={isPatient}
                    />

                    <Route exact
                        path="/dashboard/appointment-details/:id"
                        component={PatientAppointmentDetail}
                    // onEnter={isPatient}
                    />
                    <Route exact
                        path="/dashboard/rating"
                        component={AddRating} />
                    <Route path="*" component={ErrorPage} />
                </Switch>
            </div>
        );
    }
}
//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
    return {
        specializationList: state.dashboard.dashSpecializationList,
        userDetails: state.dashboard.userDetails,
		userProfDetails: state.users.userDetails,
        userUpdateSuccess: state.users.userDetails,
        //added
        specialistSearchSuccess: state.specialist.specialistSearchSuccess,

        // previous comment
        // specializationList: state.specialist.specializationList,
    };
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(dashboardActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch)
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dashboard);
